import React, { useCallback } from 'react';
import { ServicesContext } from '~/services';
import { CoreAppPaginationType, defaultApiResponseHandler } from '~/util';

export interface IcdCodeType {
    id: number;
    code: string;
    description: string;
}
export type GetIcdCodesParams = {
    q?: string;
    version?: number;
    page?: number;
    page_rows?: number;
};
export type GetIcdCodesReturnType = {
    data: {
        icd_codes: Array<IcdCodeType>;
        pagination: CoreAppPaginationType;
    };
};
export const useGetIcdCodes = () => {
    const services = React.useContext(ServicesContext);

    const getIcdCodes = useCallback(
        async (params: GetIcdCodesParams, options?: ApiRequestOptionsType) => {
            try {
                const result: GetIcdCodesReturnType = await services.api.call(
                    {
                        method: 'get',
                        url: '/core-api/icd-codes',
                        params,
                    },
                    options
                );
                return result.data;
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api]
    );

    return getIcdCodes;
};
